import { TranslateService } from '@ngx-translate/core';
import { RoleDto } from '@pages/settings-page/access-control-settings/roles/grid/interfaces';
import { ColDef } from 'ag-grid-community';

export default class UserUtils {
  static translationValueGetter = (
    colDef: ColDef,
    suffix: string,
    data: RoleDto,
    translate: TranslateService
  ): string => {
    const field = colDef.field as keyof RoleDto;

    if (!data.Editable && data.TranslationKey && data[field]) {
      return translate.instant(`${data.TranslationKey}.${suffix}`);
    } else {
      return data[field] ? String(data[field]) : '';
    }
  };
}
